export var TuiFlowInTestMode;
(function (TuiFlowInTestMode) {
    TuiFlowInTestMode["TestModeDisabled"] = "0";
    TuiFlowInTestMode["V1"] = "1";
    TuiFlowInTestMode["V2"] = "2";
    TuiFlowInTestMode["ReturningUser"] = "3";
    TuiFlowInTestMode["ReturningUserReact"] = "4";
    TuiFlowInTestMode["NewUserReact"] = "5";
})(TuiFlowInTestMode || (TuiFlowInTestMode = {}));
//# sourceMappingURL=TeachingUiConfig.js.map